import React from 'react';
import styled from '@emotion/styled';
import { OMGTheme } from '@ordermygear/theme';
import { Sale, Dealer } from '../../../../backend/shared/types';

const FooterContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${OMGTheme.colors.secondaryGrayDark};
  padding: 30px;
  footer {
    width: 100%;
    max-width: ${OMGTheme.breakpoints.md};
    margin: auto;
    color: white;
  }
  a {
    color: white;
  }
  a:hover {
    color: ${OMGTheme.colors.primaryHover};
  }
  dt, dd {
    font-size: 18px;
    display: inline-block;
  }
  dt {
    width: 100px;
  }
  @media only screen and (max-width: ${OMGTheme.breakpoints.xs}) {
    dt, dd {
      font-size: 12px;
    }
  }
`;

const Privacy = styled.div`
  width: 100%;
  background-color: ${OMGTheme.colors.grayDark};
  padding: 20px;
  text-align: center;
  color: white;
  font-size: 14px;
  > a {
      color: white;
  }
`;

type FooterProps = {
  sale: Sale;
  dealer: Dealer;
}

const Footer = (props: FooterProps) => {
  const { sale, dealer } = props;
  let service_phone, service_email, url;
  if (sale) {
    service_phone = sale.service_phone;
    service_email = sale.service_email;
    url = sale.url;
  } else {
    service_phone = dealer.service_phone;
    service_email = dealer.service_email;
    url = dealer.website;
  }
  return (
    <>
      <FooterContainer>
        <footer>
          <div>
            <dl>
              <dt>Call</dt>
              <dd>{service_phone}</dd>
            </dl>
            <dl>
              <dt>Email</dt>
              <dd>{service_email}</dd></dl>
            <dl>
              <dt>Web</dt>
              <dd><a href={url}>{url}</a></dd>
            </dl>
          </div>
        </footer>
      </FooterContainer>
      <Privacy>
        <a href="https://www.ordermygear.com/privacy.html">
          Privacy Policy
        </a>
        {' '} &amp; {' '}
        <a href="https://www.ordermygear.com/terms.html">Terms</a>
      </Privacy>
    </>
  );
};

export default Footer;